import axios from "axios";
import { URL } from "../configs/config";

export const API_BASE_URL = URL[URL.currentENV]?.api

export const LOGIN_BASE_URL = URL[URL.currentENV].login;
export const MASTERDATA_BASE_URL = URL[URL.currentENV].masterData;
const GRAPH_QL_URL = URL[URL.currentENV].graphQlAdmin;
const GET_API_URL = URL[URL.currentENV].getApiKey;

export const getToken = () => sessionStorage.getItem("token");
export const getApiKeyGQL = () => sessionStorage.getItem("apiKeyGQL");

export const headers = () => {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    "x-api-key": getApiKeyGQL(),
    "access-method": "RPM_WEB",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = headers();
    return config;
  },
  (error) => Promise.reject(error)
);

export const axiosLoginInstance = axios.create({
  baseURL: LOGIN_BASE_URL,
});

axiosLoginInstance.interceptors.request.use(
  (config) => {
    config.headers = headers();
    return config;
  },
  (error) => Promise.reject(error)
);

export const MasterDataCall = async (url, { method = "POST", data = {}, params = {}, ...options } = {}) => {
  try {
    const config = {
      url,
      method,
      data,
      ...options,
    };
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    console.error("API Error:", error?.response?.data || error.message);
    throw error;
  }
};

export const GetApiKeyCall = async () => {
  try {
    const config = {
      method: 'GET',
      url: GET_API_URL
    };

    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    console.error("API Error:", error?.response?.data || error.message);
    throw error;
  }
}

export const LoginCall = async (url, { method = "POST", data = {}, ...options }) => {
  try {
    const response = await axiosLoginInstance({
      url,
      method,
      data,
      ...options,
    });
    return response.data;
  } catch (error) {
    console.error("Login API error: ", error);
    throw error;
  }
};

export const GraphQLCall = async (query, variables = {}) => {
  try {
    const response = await axiosInstance.post(GRAPH_QL_URL, {
      query,
      variables,
    });
    return response.data;
  } catch (error) {
    console.error("GraphQL API error: ", error);
    throw error;
  }
};

export const validatedResponse = (query, res) => {

  const { statusCode, body } = res.data[query];
  const parsedBody = typeof body === 'string' ? JSON.parse(body) : body;

  if (statusCode === 303 || statusCode === 403) {
    if (parsedBody.message === "Auth Token Expired" || parsedBody.message === "you are not Authorized to access this service") {
      window.location.reload();
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("apiKeyGQL");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("userType");
    }
    throw new Error(parsedBody.message);
  }

  if (statusCode === 400)
    throw new Error(parsedBody.message);

  if (statusCode === 401)
    window.location.reload();

  return res.data[query]; // Ensure something is returned
};